import classNames from 'classnames';
import { ContentBoxHeading } from 'app/agriculture/components/ContentBox/components/ContentBoxHeading';

interface ContentBoxSectionProps {
    className?: string;
    children?: React.ReactNode;
    heading?: string;
    /**
     * Allows content within to scroll when the max-height is reached.
     * Generally works best if there is only one scrollable section in a content box.
     * @default false
     */
    scrollable?: boolean;
    /**
     * Disables the bottom border for the section
     * @default false
     */
    disableDivider?: boolean;
    timestamp?: Date;
}

export function ContentBoxSection({
    className,
    children,
    heading,
    scrollable = false,
    disableDivider = false,
    timestamp,
}: ContentBoxSectionProps) {
    return (
        <div
            className={classNames(className, 'ContentBox__section', {
                'ContentBox__section--scrollable': scrollable,
                'ContentBox__section--disableDivider': disableDivider,
            })}
        >
            {!heading ? null : <ContentBoxHeading text={heading} timestamp={timestamp} />}
            {children}
        </div>
    );
}
